import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as models from '../../../utils/models';

class DptCoverForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		scopeOfWork: Joi.string().min(5).required().label('Scope Of Work'),
		visualExaminationProcedure: Joi.string()
			.min(5)
			.required()
			.label('Visual Examination Procedure'),
		dyeExaminationProcedure: Joi.string()
			.min(3)
			.required()
			.label('Dye Penetrant Examination Procedure'),
		ndtQualification: Joi.string()
			.min(3)
			.required()
			.label('Qualification of NDT Personnel'),
		destructiveTesting: Joi.string()
			.min(3)
			.required()
			.label('Non Destructive Testing'),
		damageMechanisms: Joi.string()
			.min(3)
			.required()
			.label(
				'Damage Mechanisms affecting Fixed Equipment in the Refining Industry'
			),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'scopeOfWork',
							label: 'Scope of work',
							placeholder: 'e.g. RS-OPS-SDM-P-1015',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'visualExaminationProcedure',
							label: 'Visual Examination Procedure',
							placeholder: 'e.g. RS-TSD-MIM-P-10301',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'dyeExaminationProcedure',
							label: 'Dye Penetrant Examination Procedure',
							placeholder: 'e.g. NG-ERHA- 2019-AUT-1 MAJ-68202',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'ndtQualification',
							label: 'Qualification of NDT Personnel',
							placeholder: 'e.g. ASNT SNT-TC-1A',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'destructiveTesting',
							label: 'Non Destructive Testing',
							placeholder: 'e.g. ASNT SNT-TC-1A',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'damageMechanisms',
							label: 'Damage Mechanisms affecting Fixed Equipment',
							placeholder: 'e.g. API 571',
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default DptCoverForm;

const initialData: models.DptCoverSheetProps = {
	scopeOfWork: '',
	visualExaminationProcedure: '',
	dyeExaminationProcedure: '',
	ndtQualification: '',
	destructiveTesting: '',
	damageMechanisms: '',
};
